"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMultipleRangeInputTooltipCommon = exports.getSingleRangeInputTooltipCommon = exports.denormalizeValues = exports.normalizeValues = exports.parseOptions = exports.useGetSingleRangeInputTooltip = void 0;
const next_i18next_1 = require("next-i18next");
const react_1 = require("react");
const PriceRange_common_1 = require("./PriceRange.common");
const useGetSingleRangeInputTooltip = () => {
    const { t } = (0, next_i18next_1.useTranslation)(['filters']);
    return (0, react_1.useCallback)((options, values) => {
        const selectedOption = options.find(option => option.value === values[0]);
        if (!selectedOption || (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.caption) === PriceRange_common_1.ANY_VALUE)
            return t('any');
        return `${t('Max')}. ${selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.caption}`;
    }, [t]);
};
exports.useGetSingleRangeInputTooltip = useGetSingleRangeInputTooltip;
const parseOptions = (options) => {
    const sortedOptions = options.sort((a, b) => {
        if (a.value === null)
            return 1;
        if (b.value === null)
            return -1;
        return +a.value - +b.value;
    });
    const minValue = sortedOptions[0].value;
    const maxValue = sortedOptions[sortedOptions.length - 1].value === null &&
        sortedOptions.length > 1
        ? sortedOptions[sortedOptions.length - 2].value
        : sortedOptions[sortedOptions.length - 1].value;
    return {
        sortedOptions,
        maxValue,
        minValue,
        nullable: sortedOptions.some(({ value }) => value === null),
    };
};
exports.parseOptions = parseOptions;
const normalizeValues = (options, values) => {
    const { maxValue, minValue, nullable } = (0, exports.parseOptions)(options);
    // NOTE: Normalized income values to the range from 0 to 100.
    return values.map(value => {
        // NOTE: If there is a nullable value within the options, then it's used as right border (as 100).
        if (value === null)
            return 100;
        return +maxValue - +minValue === 0
            ? 0
            : ((+value - +minValue) / (+maxValue - +minValue)) *
                (nullable ? 90 : 100);
    });
};
exports.normalizeValues = normalizeValues;
const denormalizeValues = (options, values) => {
    const { maxValue, minValue, nullable } = (0, exports.parseOptions)(options);
    const optionValues = options.map(({ value }) => value);
    const normalizedOptionValues = (0, exports.normalizeValues)(options, optionValues);
    return values.map(value => {
        // NOTE: To get appropriate option we need to find the nearest normalized option value.
        const nearestNormalizedOptionValue = normalizedOptionValues.sort((a, b) => Math.abs(value - a) - Math.abs(value - b))[0];
        return (nullable && nearestNormalizedOptionValue === 100
            ? null
            : Math.round((nearestNormalizedOptionValue * (+maxValue - +minValue)) /
                (nullable ? 90 : 100) +
                +minValue));
    });
};
exports.denormalizeValues = denormalizeValues;
const getSingleRangeInputTooltipCommon = (options, values) => {
    var _a, _b, _c;
    const selectedOption = options.find(option => option.value === values[0]);
    return ((_a = options[0]) === null || _a === void 0 ? void 0 : _a.value) === values[0]
        ? (_b = options[0]) === null || _b === void 0 ? void 0 : _b.caption
        : `${(_c = options[0]) === null || _c === void 0 ? void 0 : _c.caption} - ${selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.caption}`;
};
exports.getSingleRangeInputTooltipCommon = getSingleRangeInputTooltipCommon;
const getMultipleRangeInputTooltipCommon = (options, values) => {
    const firstSelectedOption = options.find(option => option.value === values[0]);
    const lastSelectedOption = options.find(option => option.value === values[values.length - 1]);
    return (firstSelectedOption === null || firstSelectedOption === void 0 ? void 0 : firstSelectedOption.value) !== (lastSelectedOption === null || lastSelectedOption === void 0 ? void 0 : lastSelectedOption.value)
        ? `${firstSelectedOption === null || firstSelectedOption === void 0 ? void 0 : firstSelectedOption.caption} - ${lastSelectedOption === null || lastSelectedOption === void 0 ? void 0 : lastSelectedOption.caption}`
        : firstSelectedOption === null || firstSelectedOption === void 0 ? void 0 : firstSelectedOption.caption;
};
exports.getMultipleRangeInputTooltipCommon = getMultipleRangeInputTooltipCommon;
//# sourceMappingURL=RangeInput.utils.js.map